import React from 'react';
import { connect } from 'dva';
import { Button, Row, Col } from 'antd';
import Dimio, {DimioNotice} from '../../../components/Dimio';
import BaseComponent from '../../../components/BaseComponent';
import DimioSlidein from '../../../components/DimioSlidein';
import {Item} from './Library';

import ListPage from './ListPage';
//import FilterPrice from './FilterPrice';
import SortPrice from './SortPrice';
import FilterCity from './FilterCity';
//import SearchKeyword from './SearchKeyword';
//import SearchResult from './SearchResult';

//import EntryMap from './EntryMap';
import request from 'superagent';
import _ from 'lodash';
import Animate from 'react-move/Animate';
import { easeExpOut } from 'd3-ease';

import config from '../config/config';
import "../style/travel.scss"
const {travel} = config;

/**
 * type: loader - loading item by NOI
 */
class SalePage extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      jpy: false
    };
  }

  componentWillMount() {
    const {dispatch } = this.props;
    this.showLoading();

    const query = {};
    const self = this;

    const opt = {
      query: query,
      onSuccess({data, meta}){
        dispatch({
          type: 'travel/setData',
          items: data,
          meta: meta
        });
        self.hideLoading();
      },
      onError(error){
        self.hideLoading();
      }
    }

    this.load(travel.api.travelList, opt);
/*
    request
      .get('https://api.fixer.io/latest')
      .query({base: 'AUD', symbols: 'JPY'})
      .type('json')
      //        .then(this.apiResponse)
      .then (res => {
        const {rates} = res.body;
        this.setState({jpy: rates.JPY});
      })
      .catch(err => {

      });
      */
  }

  render() {
    const { travel } = this.props;
    const { items, orig, tMeta } = travel;
    const { jpy } = this.state;

    return (
      <section>
        <DimioNotice {...travel} />

        {tMeta &&
          <div className=''>
            <Row type="flex" gutter={24} className='mb-3'>
              {(orig && tMeta.displayItems) &&
               tMeta.displayItems.map(idx => (
                <Col key={idx} xs={24} sm={8}>
                  {orig.get(idx) &&
                  <Item item={orig.get(idx)} jpy={jpy}/>
                  }
                </Col>
              ))}
            </Row>
            <Row type="flex" justify="center">
              <Col xs={24} md={8}><Button className='btn-block' onClick={this.panel.openPanel} >他のセールも見る</Button></Col>
            </Row>
          </div>
        }

        <DimioSlidein
          fromRight={true}
          closeButton={false}
          ref={(ref) => {this.panel = ref}}
        >
          {items &&
          <div className='container SaleSlide'>
            <Row type="flex pt-3 SaleSlide__header" gutter={8}>
              <Col xs={6} lg={2}>
                <Button
                  style={{width: '100%', background: '#000', border: '1px solid #333'}}
                  onClick={this.panel.closePanel}
                  type='primary'>閉じる</Button>
              </Col>
              <Col xs={9} lg={11}>
                <SortPrice/>
              </Col>
              <Col xs={9} lg={11}>
                <FilterCity/>
              </Col>
            </Row>

            <hr className='pb-3'/>

            <ListPage jpy={jpy}/>
          </div>
          }
        </DimioSlidein>
      </section>
    );
  }
}



export default connect(({ meta, travel }) => ({
  meta, travel
}))(SalePage);


// WEBPACK FOOTER //
// ./src/pages/travel/components/SalePage.js